export { CollapseDirective } from './collapse.directive';
export { CollapseModule } from './collapse.module';



// WEBPACK FOOTER //
// ./~/angular-bootstrap-md/collapse/index.ts